var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertGreyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.12178 15.5512H8.1218C9.04661 15.5512 9.79632 14.8015 9.79632 13.8767H6.44727C6.44727 14.8015 7.19697 15.5512 8.12178 15.5512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4398 12.3919L12.9494 10.7314V7.06993C12.9494 7.06993 13.2943 2.70568 9.35405 1.96015V1.56292C9.35292 0.88346 8.80179 0.333252 8.12234 0.333252C7.44288 0.333252 6.89176 0.88346 6.89063 1.56292V1.96042C2.95673 2.70687 3.29533 7.06994 3.29533 7.06994V10.7314L1.80501 12.3918C1.66931 12.5275 1.62871 12.7316 1.70214 12.9089C1.77557 13.0862 1.94858 13.2018 2.14049 13.2019H14.1042C14.2961 13.2019 14.4691 13.0863 14.5426 12.909C14.616 12.7317 14.5755 12.5276 14.4398 12.3918V12.3919Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertGreyIcon);
export default __webpack_public_path__ + "static/media/AlertGreyIcon.6113c426.svg";
export { ForwardRef as ReactComponent };